import { axiosJWTInstance } from "../../utils/axiosJWTInstance";
import { Dispatch } from "redux";
import {
  GET_LEADERS_ATTEMPT,
  GET_LEADERS_SUCCESS,
  GET_LEADERS_FAILURE,
} from "../constants";

// getLeaders actions
const getLeadersAttempt = () => ({
  type: GET_LEADERS_ATTEMPT,
});

const getLeadersSuccess = (payload: any) => ({
  type: GET_LEADERS_SUCCESS,
  payload,
});

const getLeadersFailure = (error: string) => ({
  type: GET_LEADERS_FAILURE,
  payload: {
    error,
  },
});

export const getLeadersRequest = (data: any, paramsToAdd?:any) => (dispatch: Dispatch) => {
  dispatch(getLeadersAttempt());

  const params2 = {
    entity: "leaders",
    ...paramsToAdd
  }

  const searchParams = new URLSearchParams(params2);
  const webUrl = `/Orders?${searchParams.toString()}`;

  return axiosJWTInstance
    .post(webUrl, data, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "content-type": "application/json",
      }
    })
    .then((res) => {
        res.data.data = res.data.data.map((x: any) => {
            return {...x, joined: `${x.leaderId} - ${x.leaderName}`}
        });
        return res.data;
    })
    .then((payload) => {
      dispatch(getLeadersSuccess(payload));
    })
    .catch((error) => {
      dispatch(getLeadersFailure(error.message));
    });
};
